import { render, staticRenderFns } from "./RightTabs.vue?vue&type=template&id=74dbf655&scoped=true&"
import script from "./RightTabs.vue?vue&type=script&lang=js&"
export * from "./RightTabs.vue?vue&type=script&lang=js&"
import style0 from "./RightTabs.vue?vue&type=style&index=0&id=74dbf655&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dbf655",
  null
  
)

export default component.exports